const calendlyAssessmentStyle = {
  container: {
    padding: "2rem",
    marginTop: "2rem",
    width: "100%",
  },
  headline: {
    textAlign: "center",
    fontSize: "1.25rem",
    marginBottom: "1rem",
  },
  ratingContainer: {
    paddingTop: "10px",
  },
  center: {
    textAlign: "center",
  },
  noteContainer: {
    padding: "0.5rem",
    background: "#fafafa",
  },
  collapsedNote: {
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
    maxHeight: "6rem",
  },
  assessmentContainer: {
    marginTop: "1rem",
    marginLeft: "72px",
  },
  topSpace: {
    paddingTop: "1rem",
  },
};
export default calendlyAssessmentStyle;
